import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_158: DocMigration = {
  maxSchemaVersion: "0.0.158",
  description: "New mini hip/mini shed and full return orientations",
  apply(json: any) {
    const { settings: allSettings, roofs } = json;

    const migrateOrientation = (roofSettings: any) => {
      if (roofSettings.allowFullReturnOnRear !== undefined) {
        roofSettings.fullReturnOrientation = roofSettings.allowFullReturnOnRear
          ? "FRONT_AND_BACK_FACES"
          : "FRONT_FACES";
        delete roofSettings.allowFullReturnOnRear;
      }

      if (roofSettings.allowMiniHipOnRear !== undefined) {
        roofSettings.miniHipOrientation = roofSettings.allowMiniHipOnRear ? "FRONT_AND_BACK_FACES" : "FRONT_FACES";
        delete roofSettings.allowMiniHipOnRear;
      }
    };

    // roof settings
    for (const settingsId in allSettings) {
      const settings = allSettings[settingsId];
      if (settings.type !== "ROOF_SETTINGS") {
        continue;
      }

      migrateOrientation(settings);
    }

    // roof instances
    for (const roofId in roofs) {
      const { roofSettings = {} } = roofs[roofId];

      migrateOrientation(roofSettings);
    }

    return json;
  },
};

export default migration_0_0_158;
